module.exports = __webpack_public_path__ + "static/sir-salon-impact-e0da08965aaca489479fbcf6df66ec40.jpg";